if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.jsProductCard = {
  listen: () => {
    let variantSelects = document.querySelectorAll('.product-form-quick-add .product-card--variants-select');
    variantSelects.forEach(variantSelect => {
      let optionsWrapper = variantSelect.closest('.product-form-quick-add').querySelector('.product-card--options');
      let submitBtn = variantSelect.closest('.product-form-quick-add').querySelector('.add-to-cart-button');
      let options = optionsWrapper.querySelectorAll('.product-card--option select');

      if (options.length == 2) {
        let firstSelect = options[0];
        firstSelect.addEventListener('change', () => {
          let changedOptionType = firstSelect.getAttribute('data-option-title').toLowerCase();
          let variantsByOption = variantSelect.querySelectorAll(`option[data-option--${changedOptionType}="${firstSelect.value}"]`);
          let secondSelect = options[1];
          secondSelect.selectedIndex = 0;

          if (submitBtn) {
            submitBtn.setAttribute('disabled', '');
          }

          let secondOptionType = secondSelect.getAttribute('data-option-title').toLowerCase();
          secondSelect.querySelectorAll('option').forEach(secondOption => {
            secondOption.setAttribute('disabled', '');
          });
          secondSelect.querySelectorAll('option').forEach(secondOption => {
            variantsByOption.forEach(variantOption => {
              if (secondOption.textContent == variantOption.getAttribute(`data-option--${secondOptionType}`)) {
                if (!variantOption.hasAttribute('disabled')) {
                  secondOption.removeAttribute('disabled');
                }
              }
            });
          });
          secondSelect.addEventListener('change', () => {
            if (firstSelect.value && secondSelect.value) {
              let selectedVariant = variantSelect.querySelector(`option[data-option--${changedOptionType}="${firstSelect.value}"][data-option--${secondOptionType}="${secondSelect.value}"]`);

              if (selectedVariant) {
                variantSelect.value = selectedVariant.getAttribute('value');
              }

              if (submitBtn) {
                submitBtn.removeAttribute('disabled');
              }
            }
          });
        });
      }
    });
  },
  showForm: () => {
    let showFormBtns = document.querySelectorAll('.js-trigger-product-form');
    showFormBtns.forEach(triggerBtn => {
      triggerBtn.addEventListener('click', () => {
        let productCard = triggerBtn.closest('.product-card');

        if (productCard) {
          let background = productCard.querySelector('.active-form-background');
          let modalForm = productCard.querySelector('.product-form--modal');
          let addToCartBtn = productCard.querySelector('.add-to-cart-button-desktop');

          if (background) {
            background.classList.remove('hidden');
          }

          if (modalForm) {
            modalForm.classList.remove('hidden');
          }

          if (triggerBtn) {
            triggerBtn.classList.add('hidden');
          }

          if (addToCartBtn) {
            addToCartBtn.classList.remove('hidden');
          }
        }
      });
    });
  },
  showMobileForm: () => {
    let showFormBtns = document.querySelectorAll('.js-trigger-product-form-mobile');
    showFormBtns.forEach(triggerBtn => {
      triggerBtn.addEventListener('click', () => {
        let productCard = triggerBtn.closest('.product-card');

        if (productCard) {
          let background = productCard.querySelector('.active-form-mobile-background');
          let addToCartBlock = productCard.querySelector('.product-card__add-to-cart');

          if (background) {
            background.classList.remove('hidden');
          }

          if (addToCartBlock) {
            addToCartBlock.classList.remove('hidden');
          }
        }
      });
    });
  },
  closeMobileForm: () => {
    let showFormBtns = document.querySelectorAll('.js-close-product-form-mobile');
    showFormBtns.forEach(triggerBtn => {
      triggerBtn.addEventListener('click', () => {
        let productCard = triggerBtn.closest('.product-card');

        if (productCard) {
          let background = productCard.querySelector('.active-form-mobile-background');
          let addToCartBlock = productCard.querySelector('.product-card__add-to-cart');

          if (background) {
            background.classList.add('hidden');
          }

          if (addToCartBlock) {
            addToCartBlock.classList.add('hidden');
          }
        }
      });
    });
  },
  closeForm: () => {
    let closeFormBtns = document.querySelectorAll('.js-close-product-form');
    closeFormBtns.forEach(triggerBtn => {
      triggerBtn.addEventListener('click', () => {
        let productCard = triggerBtn.closest('.product-card');

        if (productCard) {
          let background = productCard.querySelector('.active-form-background');
          let modalForm = productCard.querySelector('.product-form--modal');
          productCard.querySelectorAll('[data-add-to-cart]');
          let showFormBtn = productCard.querySelector('.js-trigger-product-form');
          let internalQuickAddBtn = productCard.querySelector('.add-to-cart-button-desktop');

          if (background) {
            background.classList.add('hidden');
          }

          if (modalForm) {
            modalForm.classList.add('hidden');
          }

          if (internalQuickAddBtn) {
            internalQuickAddBtn.classList.add('hidden');
          }

          if (showFormBtn) {
            showFormBtn.classList.remove('hidden');
          }
        }
      });
    });
  }
};
